import { z } from 'zod';

export const DataSchema = z.object({
    data_labels: z.array(z.string()),
    data_history: z.array(z.number().nullable()),
    data_todo: z.array(z.number().nullable()),
});
export type DataType = z.infer<typeof DataSchema>;
